import { API } from "../../../utils";

export const getPosSetting = async () => {
  const res = await API.get(`pos-settings`);
  return res.data;
};
export const editTemplate = async (query) => {
  const res = await API.put("pos-settings/keypad-template", query);
  return res.data;
};

export const updatePosSettings = async (query) => {
  const res = await API.put("pos-settings", query);
  return res.data;
};
